import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
export default function Checkbox({ id, name, checked, disabled, indeterminate, onChange, }) {
    const ref = useRef(null);
    useEffect(() => {
        if (typeof indeterminate === 'boolean') {
            ref.current.indeterminate = !checked && indeterminate;
        }
    }, [ref, indeterminate, checked]);
    return (_jsx("input", { ref: ref, id: id, name: name, type: "checkbox", checked: checked, onClick: (e) => e.stopPropagation(), onChange: (e) => onChange === null || onChange === void 0 ? void 0 : onChange(e.target.checked, e), disabled: disabled, className: "h-4 w-4 appearance-auto rounded-sm border-gray-300 bg-gray-100 text-indigo-600 focus:ring-2 focus:ring-indigo-500" }));
}
